import React, { Component } from "react";
import { connect } from "react-redux";
import WithAjax from "../../../common/helpers/WithAjax";
import { clearSkillVendorCurrentProfile, fetchSkillVendorProfileSuccess } from "../../../../actions/pages/skillvendor-page";
import StatusBox from "./StatusBox";
import SpecialitiesBox from "./SpecialitiesBox";
import ProfileActions from "./ProfileActions";

class ProfileBase extends Component {
  componentDidMount() {
    this.fetchProfile();
  }

  componentDidUpdate(prevProps) {
    if (this.props.profileData === null && !this.props.isLoading) {
      this.fetchProfile();
    }
  }

  componentWillUnmount() {
    this.props.clearSkillVendorCurrentProfile();
  }

  fetchProfile() {
    let url = "skillvendors/" + this.props.skillVendorId + "/profiles/" + this.props.profileUrlPart;

    this.props.ajax.get(url, true, (data) => {
      this.props.fetchSkillVendorProfileSuccess(data);
    });
  }

  render() {
    if (this.props.profileData === null) {
      return <div />;
    }

    let profileData = this.props.profileData;

    return (
      <div>
        <ProfileActions />
        <div className="row">
          <StatusBox donotuse={profileData.DoNotUse} />
          <SpecialitiesBox />
        </div>
        {this.props.render(profileData, this.props.skillVendorId)}
        <ProfileActions />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview.Id,
  profileData: state.skillVendorPage.currentProfile,
  isLoading: state.common.isLoading,
});
const mapDispatchToProps = (dispatch) => ({
  clearSkillVendorCurrentProfile() {
    dispatch(clearSkillVendorCurrentProfile());
  },
  fetchSkillVendorProfileSuccess(currentProfile) {
    dispatch(fetchSkillVendorProfileSuccess(currentProfile));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAjax(ProfileBase));
